import styled from "styled-components";
import { PageHero } from "../components";
import aboutImg from "../assets/hero-bcg.jpeg";

const AboutPage = () => {
  return (
    <main>
      <PageHero title='about' />
      <Wrapper className='page section section-center'>
        <img src={aboutImg} alt='nice desk' />
        <article>
          <div className='title'>
            <h2>our story</h2>
            <div className='underline'></div>
          </div>
          <p>
            Tradelane has been a go-to source for footwear for many years. Our
            mission is to offer a wide range of fashionable and comfortable
            footwear options. We carefully curate products from top brands in
            the industry to provide our customers with a diverse selection of
            styles. As a reseller, sustainability is a priority for us. We
            strive to make environmentally responsible decisions in all aspects
            of our business. Our commitment to sustainability, along with our
            premium product selection and exceptional customer service, has made
            Tradelane a trusted name in footwear. Join us on our journey to
            bring you the best in fashion and comfort.
          </p>
        </article>
      </Wrapper>
    </main>
  );
};

const Wrapper = styled.section`
  display: grid;
  gap: 4rem;
  img {
    width: 100%;
    display: block;
    border-radius: var(--radius);
    height: 500px;
    object-fit: cover;
  }
  p {
    line-height: 2;
    max-width: 45em;
    margin: 0 auto;
    margin-top: 2rem;
    color: var(--clr-grey-5);
  }
  .title {
    text-align: left;
  }
  .underline {
    margin-left: 0;
  }
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
`;
export default AboutPage;
